type ButtonProps = {
  label: string;
  disabled:boolean
  onClick: () => void;
};

export const Button = ({ label, onClick, disabled }: ButtonProps) => {
  return (
    <button className="btn-annulla" onClick={onClick}>
      {label}
    </button>
  );
};
